<!--<app-nav-menu></app-nav-menu>-->


<div class="container">
  <router-outlet></router-outlet>
  <router-outlet name="print"></router-outlet>
</div>
